import documents_treat from "includes/documents_treat";
import genRequest from "includes/request";
import DocIconDownloader from "Pages/Documents/components/DocIconDownloader/DocIconDownloader";
import { useQuery } from "react-query";
import "./DocumentsButtonBottomBar.css";

function DocumentsButton({ postId, toggleDocsExtend, documents }) {
    const fetchDocs = () => {
        let req = genRequest("Documents/DocumentOfPostAndType/" + postId + "/4")
            .then((resp) => documents_treat(resp, "PublishedDate"));
        return (req);
    };

    const { isLoading, data } = useQuery(
        ["Documents", "DocumentOfPostAndType", postId, 4],
        fetchDocs,
        {
            enabled: (postId && !documents ? true : false)
        }
    );


    // Documents given by the parent (ex: edit preview) take precedence over the fetched ones
    const docs = documents ?? data ?? [];
    let count = docs.length;

    if ((!postId && !documents) || isLoading || (!isLoading && !count))
        return (false);

    return (
        <div className="docDesktop">
            {docs.map(doc => (
                <DocIconDownloader key={doc.DocumentId ?? doc.TempId} doc={doc} />
            ))}
            {/* <Button className="post-docs-btn btn-primary radius-3" onClick={toggleDocsExtend} title={t("Posts.DISPLAY_DOCS")}>
				<FontAwesomeIcon icon={faFilePdf} className="me-2" />
				{count} {t("Posts.DOCS_BTN", { count })}
			</Button> */}
        </div>
    );
}

export default DocumentsButton;